export const getIconColour = (
  buttonStyleType: 'primary' | 'secondary' | 'text',
  disabled?: boolean,
  iconColour?: string,
) => {
  if (disabled) return 'var(--grey-400)';
  if (iconColour) return iconColour;
  if (buttonStyleType === 'secondary' || buttonStyleType === 'text') return 'var(--black)';

  return 'var(--white)';
};
